module.exports = __webpack_public_path__ + "static/media/ENT-ENT-General Ear Condition History-2@3x.2aa60e01.png";